var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('v-progress-linear',_vm._b({staticClass:"loading-indicator",attrs:{"indeterminate":"","absolute":"","color":"orange"}},'v-progress-linear',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }